<template>
  <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
    <v-layout row wrap>
      <v-flex
        xs12
        md12
        lg12
        xl12
        style="padding:15px;padding-bottom:2px !important"
        ><!--Row #1-->
        <v-layout row wrap>
          <v-flex
            xs12
            sm12
            md10
            lg10
            xl10
            style="padding:15px;padding-bottom:0px;"
          >
            <div style="padding-top:23px;font-weight:bolder;font-size:20px">
              مدیریت بخش های صفحه اول
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md12 lg5 xl5 class="pa-5">
        <v-card>
          <v-card-title>بخش دوم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-row v-for="(item,index) in Section2.Titles" :key="index">
                  <v-col cols="6">
                    <v-text-field v-model="Section2.Titles[index]"  outlined dense :label="'عنوان'+(index+1)"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <custom-picker @Selected="Section2.Colors[index] = $event" :color="Section2.Colors[index]" :label="'رنگ عنوان '+(index+1)"></custom-picker>
                  </v-col>
                 
                </v-row>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                  <f-up  @RetunedFileName="Section2.Image = $event" Root="ELOGO" Folder="CONTENT" BtnTitle="عکس"></f-up>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SEC2',Section2)"  outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-title>بخش پنجم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-row>
                  <v-col cols="6" v-for="(item,index) in Section5.Titles" :key="index">
                    <v-text-field   v-model="Section5.Titles[index]"  outlined dense :label="'عنوان '+(index+1)  "></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-textarea  v-model="Section5.Text"  outlined dense label="متن "></v-textarea>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field  v-model="Section5.BtnText"  outlined dense label="عنوان دکمه"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field  v-model="Section5.BtnLink"  style="direction:ltr" outlined dense label="لینک دکمه"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <f-up v-for="(item,index) in Section5.Image" :key="index"  @RetunedFileName="Section5.Image[index] = $event" Root="ELOGO" Folder="CONTENT" BtnTitle="عکس"></f-up>
                  </v-col>
                </v-row>
                
              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SEC5',Section5)"  outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-title>بخش نهم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section9.Title"  outlined dense label="عنوان  "></v-text-field>
                <v-text-field  v-model="Section9.EnTitle"  outlined dense label="عنوان انگلیسی  "></v-text-field>
                <v-textarea  v-model="Section9.Text" style="direction:ltr"  outlined dense label="متن "></v-textarea>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SEC9',Section9)" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 lg3 xl3 class="pa-5">
        <v-card>
          <v-card-title>بخش سوم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field v-for="(item,index) in Section3.Titles" :key="index" v-model="Section3.Titles[index]"  outlined dense :label="'عنوان'+(index+1)"></v-text-field>
                <v-textarea  v-model="Section3.Text"  outlined dense label="متن"></v-textarea>
                <v-text-field  v-model="Section3.BtnText"  outlined dense label="عنوان دکمه"></v-text-field>
                <v-text-field  v-model="Section3.BtnLink"  style="direction:ltr" outlined dense label="لینک دکمه"></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SEC3',Section3)" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-title>بخش ششم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section6.Title"  outlined dense label="عنوان فارسی "></v-text-field>
                <v-text-field  v-model="Section6.EnTitle" style="direction:ltr"  outlined dense label="عنوان انگلیسی"></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SEC6',Section6)" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-title>بخش هشتم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section8.Title"  outlined dense label="عنوان فارسی "></v-text-field>
                <v-text-field  v-model="Section8.EnTitle" style="direction:ltr"  outlined dense label="عنوان انگلیسی"></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SEC8',Section8)" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-title> عکس های معلق</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <f-up v-for="(item,index) in Section1.Image" :key="index"  @RetunedFileName="Section1.Image[index] = $event" Root="ELOGO" Folder="CONTENT" :BtnTitle="' عکس'  + (index + 1)"></f-up>
              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SEC1',Section1)" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 lg4 xl4 class="pa-5">
        <v-card>
          <v-card-title>بخش چهارم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section4.Title"  outlined dense label="عنوان "></v-text-field>
                <v-text-field  v-model="Section4.SmallText"  outlined dense label="عنوان ریز"></v-text-field>
                <v-textarea  v-model="Section4.Text"  outlined dense label="متن "></v-textarea>
                <custom-picker @Selected="Section4.SmallTextColor = $event" :color="Section4.SmallTextColor" label="رنگ عنوان ریز"></custom-picker>
                <v-text-field  v-model="Section4.BtnText"  outlined dense label="عنوان دکمه"></v-text-field>
                <v-text-field  v-model="Section4.BtnLink"  style="direction:ltr" outlined dense label="لینک دکمه"></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SEC4',Section4)"  outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-title>بخش هفتم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section7.Title"  outlined dense label="عنوان  "></v-text-field>
                <v-textarea  v-model="Section7.Text" style="direction:ltr"  outlined dense label="متن "></v-textarea>
                <custom-picker @Selected="Section7.BgColor = $event" :color="Section7.BgColor" label="رنگ  زمینه"></custom-picker>
                <f-up  @RetunedFileName="Section7.Image = $event" Root="ELOGO" Folder="CONTENT" BtnTitle="عکس"></f-up>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SEC7',Section7)" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
     
    </v-layout>

    <template
      ><!--Loading Dialog-->
      <div class="vld-parent">
        <loading
          color="#f75314"
          :width="parseInt(45)"
          :height="parseInt(45)"
          background-color="#fff"
          :active.sync="isLoading"
          :is-full-page="true"
        ></loading>
      </div>
    </template>
  </div>
</template>

<script>
const axios = require("axios");
const ApiUrl = require("../../../constant/apiurl");
const MSGHNDL = require("../../../constant/MessageHandler");
import { mapState, mapMutations, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { VueEditor } from "vue2-editor";
export default {
  name: "index",
  components: {
    Loading,
    VueEditor
  },
  data: () => ({
    isLoading:false,
    Section1:{
      Image:["","","","",""]
    },
    Section2:{
      Image:"",
      Titles:["","",""],
      Colors:["#ffffff","#ffffff","#ffffff"]
    },
    Section3:{
      Text:"",
      BtnText:"",
      BtnLink:"",
      Titles:["","",""]
    },
    Section4:{
      SmallText:"",
      SmallTextColor:"#ffffff",
      Title:"",
      Text:"",
      BtnTitle:"",
      BtnLink:""
    },
    Section5:{
      Image:["",""],
      Titles:["",""],
      Text:"",
      BtnText:"",
      BtnLink:""
    },
    Section6:{
      Title:"",
      EnTitle:""
    },
    Section7:{
      Title:"",
      Text:"",
      Image:"",
      BgColor:"#ffffff"
    },
    Section8:{
      Title:"",
      EnTitle:""
    },
    Section9:{
      Text:"",
      Title:"",
      EnTitle:""
    },
  }),
  async created() {
    let vm = this;
    axios.interceptors.request.use(
      config => {
        vm.isLoading = true;
        return config;
      },
      error => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => {
        vm.isLoading = false;
        return response;
      },
      error => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );
      vm.loadCategories();
  },
  computed: {
    LANG() {
      return this.$store.getters.GetLang;
    }
  },
  watch: {
    LANG(nL, oL) {
      this.loadCategories();
    }
  },
  methods: {
    async AddOption(key,val)
    {
      var vm = this;
      var Model = {};
      Model.O_Key = key;
      Model.O_Value = JSON.stringify(val);
      await axios.post(ApiUrl.AddOption,Model)
      .then(async (res)=>{
          var data = res.data;
          if(data.status)
          {
              MSGHNDL.OK(data.msg);
              await vm.loadCategories();
          }
          else
          {
              MSGHNDL.ERR(data.msg);
          }
      })
      .catch((error)=>{
          console.error(error);
          MSGHNDL.ERR(error);
      });
    },
    async loadCategories()
      {
          let vm = this;
          vm.isLoading  = true;
          await axios.post(ApiUrl.LoadOptions,{}).then(async (res)=>{
              let data = res.data;
              console.warn(data);
              if(data.status)
              {
                  if(data.data.length > 0)
                  {
                      data.data.forEach(item => {
                          if(item.o_Key == "SEC2")
                          {
                              vm.Section2 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SEC3")
                          {
                              vm.Section3 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SEC4")
                          {
                              vm.Section4 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SEC5")
                          {
                              vm.Section5 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SEC6")
                          {
                              vm.Section6 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SEC7")
                          {
                              vm.Section7 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SEC8")
                          {
                              vm.Section8 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SEC9")
                          {
                              vm.Section9 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SEC1")
                          {
                              vm.Section1 = JSON.parse(item.o_Value);
                          }
                          
                      });
                  }
              }
              vm.isLoading = false
          }).catch((err)=>{
              console.error(err);
          });
      },

    SeoChanged(data) {
      this.seo = data;
    }
  }
};
</script>